module.exports = __webpack_public_path__ + "img/orbit-learn-more-modal-background.8ad627de.png";